import ApiStore from './ApiStore';
import axios from 'axios';

class AuthenStore extends ApiStore {

  getConfig() {
    return this.wrapResponse(axios.get('//config_sidebar'));
  }

  switchLanguage(lang,completeFunc){
    axios.post('/authen/change_language',{lang:lang})
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }


  changeOrg(orgId) {
    return this.wrapResponse(axios.post('/authen/login_org/'+orgId,{
        }));
  }

  loadProfile(){
    return this.wrapResponse(axios.get('/authen/profile'));
  }

  loadOrgList(completeFunc){
    
    axios.get('/authen/orglist')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }
}

export default new AuthenStore();



// WEBPACK FOOTER //
// ./src/stores/AuthenStore.js